import { environment } from '@adm-web-env/environment';
import { AbstractControl, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function buildGooglePublicUrl(url: string): string {
  const bucket = environment.googlePublicBucket;
  if (url.startsWith('/')) {
    return bucket + url;
  }
  return bucket + '/' + url;
}

export function getFormErrors(form: AbstractControl | null): ValidationErrors | null {
  if (form === null) {
    return null;
  }
  if (form instanceof UntypedFormControl || form instanceof FormControl) {
    // Return FormControl errors or null
    return form.errors;
  }
  if (form instanceof UntypedFormGroup || form instanceof FormGroup) {
    const groupErrors = form.errors;
    // Form group can contain errors itself, in that case add'em
    const formErrors: ValidationErrors = groupErrors ?? {};
    Object.keys(form.controls).forEach(key => {
      // Recursive call of the FormGroup fields
      const error = getFormErrors(form.get(key));
      if (error !== null) {
        // Only add error if not null
        formErrors[key] = error;
      }
    });
    // Return FormGroup errors or null
    return Object.keys(formErrors).length > 0 ? formErrors : null;
  }
  return null;
}

export function getBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
